// Converted from makeStyles to simple style object
const styles = {
    containerForm: {
        marginBottom: "20px",
    },
    formControl: {
        margin: "8px",
        width: "100%",
    },
    selectEmpty: {
        marginTop: "16px",
    },
    paper: {
        padding: "40px",
        margin: "16px",
    },
    avatar: {
        margin: "8px",
    },
    form: {
        marginTop: "8px",
    },
    submit: {
        margin: "24px 0 16px",
        backgroundImage: `linear-gradient(to right, #00d2ff 0%, #3a7bd5  51%, #00d2ff  100%)`,
        backgroundSize: "200% auto",
        display: "block",
        width: "100%",
    },
    chipContainer: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "4px",
        margin: 0,
    },
    chip: {
        margin: "4px",
    },
};

const useStyles = () => styles;
export default useStyles;
